import {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {UyoControl} from '../CardEditor/actions/UyoControl/UyoControl';
import {selectEditorDisabled} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';

export const ImageEditor = () => {
  const {canvas} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const activeObject = canvas?.getActiveObject();
  const editorDisabled = useSelector(selectEditorDisabled);

  useEffect(() => {
    if (activeObject) {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  }, [activeObject]);

  return (
    <div className="card_editor">
      <div className="edit_box image-editor">
        <UyoControl editorDisabled={editorDisabled} />
      </div>
    </div>
  );
};
